// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retry = (fn: () => Promise<any>, retriesLeft = 5, interval = 1000): Promise<never> =>
  new Promise((resolve, reject) => {
    return (
      fn()
        .then(resolve)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          if (retriesLeft === 0) {
            reject(error)
            return
          }
          setTimeout(() => {
            retry(fn, retriesLeft - 1, interval).then(resolve, reject)
          }, interval)
        })
    )
  })
